import { render, staticRenderFns } from "./actual-investor-header-menu.vue?vue&type=template&id=2a6eac9e&"
var script = {}
import style0 from "../../assets/styles/controls/_ActualHeader.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports